"use client";

import { useEffect, useState } from "react";
import Logo from "../Logo";
import Loader from "../Loader";
import { useContent } from "../../content/current";
export default function Header() {
  const content = useContent();
  const [activeLanguage, setActiveLanguage] = useState("es");

  useEffect(() => {
    setActiveLanguage(window.location.pathname.startsWith("/en") ? "en" : "es");
  }, []);
  const switchLanguage = (locale) => {
    if (locale === activeLanguage) return;

    const { pathname, search, hash } = window.location;
    const cleanPath = pathname.replace(/^\/(es|en)(?=\/|$)/, "") || "/";
    const nextPath = `/${locale}${cleanPath === "/" ? "" : cleanPath}${search}${hash}`;

    document.documentElement.classList.add("is-language-leaving");
    window.setTimeout(() => {
      window.location.href = nextPath;
    }, 220);
  };
  

  return (
   <>
   <div id="header">
    <div id="mail" className="link"><a href={content.header.emailHref}>{content.header.email}</a></div>
    <div id="language" aria-label="Idioma">
      <button
        className={activeLanguage === "es" ? "is-active" : ""}
        type="button"
        onClick={() => switchLanguage("es")}
      >
        ES
      </button>
      <button
        className={activeLanguage === "en" ? "is-active" : ""}
        type="button"
        onClick={() => switchLanguage("en")}
      >
        EN
      </button>
    </div>
    <div id="linkedin" className="link"><a href={content.header.linkedinHref} target="_blank">{content.header.linkedin}</a></div>
    <Logo className="logo"></Logo>
    <Loader></Loader>
   </div>
   </>
  );
}
